import { Component, OnInit } from '@angular/core';
import { Entity } from '../entity';
import { EntityService } from '../entity.service';
import { User } from '../../user/user';
import { UserService } from '../../user/user.service';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StateService } from '../../state/state.service';
import { State } from '../../state/state';
import { City } from '../../city/city';
import { CityService } from '../../city/city.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilityService } from  '../../utility.service';
import { Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-create-entity',
  templateUrl: './create-entity.component.html',
  styleUrls: ['./create-entity.component.css']
})
export class CreateEntityComponent implements OnInit {
  entity = new Entity();
  entitydata : any = {}
  submitted = false;
  cities: City[];
  states: State[];
  users:User[];
  message: string;
  entityForm: FormGroup;
  public isupdate = false;
public FormName = "Add Entity";
gstPattern = "^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$";

  constructor(
    private entityService:EntityService,
    private cityService: CityService,
    private stateService: StateService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private util:UtilityService, 
    public toastr: ToastrManager,
    private location: Location,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.entity.active = 1;
    this.getStates();
    this.getcities();
    this.getusers();
    if(this.route.snapshot.paramMap.get('entityid') != null)
			{
        const entityid = +this.route.snapshot.paramMap.get('entityid');
				 if(entityid > 0)
				 {
					 this.getEntity(entityid);
				 }
				 this.isupdate = true;
				 this.FormName = "Update Entity";
				 
      }
      this.entityForm = this.formBuilder.group({			
        entityname: [this.entity.entityname,[Validators.required, Validators.required]],
        entityaddress: [this.entity.entityaddress,[Validators.required, Validators.required]],
        stateid: [this.entity.stateid,[Validators.required, Validators.required]],
        cityid: [this.entity.cityid,[Validators.required, Validators.required]],
        pincode: [this.entity.pincode,[Validators.required, Validators.required]],
        gstin: [this.entity.gstin,[Validators.required, Validators.required, Validators.pattern(this.gstPattern)]],
        active: [this.entity.active,[Validators.required, Validators.required]]
      });	
  }

  // convenience getter for easy access to form fields
get f() {
  return this.entityForm.controls
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.entityForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{
    if(this.isupdate){
      this.updateEntity();
    }
    else{
      this.addEntity();
    }
  }
}

public addEntity() {
  this.save();
}
public updateEntity() {
  this.update();
}

private save(): void {
  this.entitydata = this.entity;
   this.entitydata.createdby = this.auth.currentUserValue.userid
  this.entityService.addEntity(this.entitydata).subscribe(() => 
  { 
  this.util.showSuccess("Entity added successfully.");
  this.router.navigate(['/entity-list']);
  });
}


update(): void {
  //this.submitted = true;
  this.submitted = true;
  this.entitydata = this.entity;
  this.entitydata.modifiedby = this.auth.currentUserValue.userid;
  this.entitydata.modifiedon = Date.now();
  this.entityService.updateEntity(this.entitydata)
      .subscribe(() => 
	  { 
	  this.util.showSuccess("Entity update successfully.");
      this.router.navigate(['/entity-list']);
	  });
}

getStates() {
  return this.stateService.getStates()
             .subscribe(
               states => {
                console.log(states);
                this.states = states.filter(item => item.active == 1);
               }
              );
}

getcities() {
return this.cityService.getCities()
           .subscribe(
            cities => {
              console.log(cities);
              this.cities = cities.filter(item => item.active == 1)
             }
            );
}

getusers() {
  return this.userService.getUsers()
             .subscribe(
              users => {
                console.log(users);
                this.users = users
               }
              );
  }

  
getEntity(entityid) {
  return this.entityService.getEntity(entityid)
             .subscribe(
               entity => {
                console.log(entity);
                this.entity = entity
                //this.getCityByState(this.vendor.stateid);
               }
              );
}

public onStateChangeObj(filterstateID){
	//	this.FiltercityArray =  this.cityArray.filter(c => c.stateid === filterstateID);
		this.getCityByState(filterstateID);
  }
  
getCityByState(stateid) {
  return this.cityService.getCityByState(stateid)
             .subscribe(
               cities => {
                console.log(cities);                  
                this.cities = cities
               }
              );
  }
}
